import React from 'react';

function Report() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <h1 className="text-4xl font-bold text-blue-600">Hello, Welcome To Reports!</h1>
    </div>
  );
}

export default Report;
